import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: GoalCreateInput!
  ) {
    createOneGoal(data: $data) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Finalidade criada`, mutationTypes.CREATE)
)
